/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  fill?: string;
};

const DiscoverDinersCard: FC<IProps> = ({ width = 40, height = 28, fill = "none" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 70 48"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className="bg-white rounded-lg border bprder-gray-3"
  >
    <rect x="0.5" y="0.5" width="69" height="47" rx="5.5" fill="white" stroke="#D9D9D9"/>
    <path d="M38.09 38.9998C45.8851 39.0375 53 32.5842 53 24.7339C53 16.1499 45.8851 10.2157 38.09 10.2189H31.3813C23.4933 10.2157 17 16.1515 17 24.7339C17 32.5858 23.4933 39.0375 31.3813 38.9998H38.09Z" fill="#0079BE"/>
    <path d="M31.4133 11.4084C24.2047 11.4109 18.3642 17.3066 18.3618 24.5833C18.3642 31.8593 24.2047 37.755 31.4133 37.7574C38.6228 37.755 44.4656 31.8593 44.4664 24.5833C44.4656 17.3066 38.6236 11.4109 31.4133 11.4084ZM23.1409 24.5833C23.1394 22.9009 23.6454 21.2571 24.593 19.8668C25.5405 18.4766 26.8854 17.4045 28.4518 16.7907V32.3751C26.8852 31.7618 25.5402 30.6899 24.5926 29.2997C23.6451 27.9095 23.1391 26.2657 23.1409 24.5833ZM34.374 32.3783V16.7899C35.9417 17.4028 37.2877 18.4748 38.2359 19.8655C39.1841 21.2563 39.6903 22.9009 39.6882 24.5841C39.69 26.2673 39.1837 27.9118 38.2355 29.3024C37.2873 30.6931 35.9415 31.7651 34.374 32.3783Z" fill="white"/>
    <path d="M38.09 38.9998C45.8851 39.0375 53 32.5842 53 24.7339C53 16.1499 45.8851 10.2157 38.09 10.2189H31.3813C23.4933 10.2157 17 16.1515 17 24.7339C17 32.5858 23.4933 39.0375 31.3813 38.9998H38.09Z" fill="#0079BE"/>
    <path d="M31.4133 11.4084C24.2047 11.4109 18.3642 17.3066 18.3618 24.5833C18.3642 31.8593 24.2047 37.755 31.4133 37.7574C38.6228 37.755 44.4656 31.8593 44.4664 24.5833C44.4656 17.3066 38.6236 11.4109 31.4133 11.4084ZM23.1409 24.5833C23.1394 22.9009 23.6454 21.2571 24.593 19.8668C25.5405 18.4766 26.8854 17.4045 28.4518 16.7907V32.3751C26.8852 31.7618 25.5402 30.6899 24.5926 29.2997C23.6451 27.9095 23.1391 26.2657 23.1409 24.5833ZM34.374 32.3783V16.7899C35.9417 17.4028 37.2877 18.4748 38.2359 19.8655C39.1841 21.2563 39.6903 22.9009 39.6882 24.5841C39.69 26.2673 39.1837 27.9118 38.2355 29.3024C37.2873 30.6931 35.9415 31.7651 34.374 32.3783Z" fill="white"/>
  </svg>

);

export default DiscoverDinersCard;
